import { AccountsWithCurrency } from '@/shared/services/account';
import { CurrencyForAccountFragment } from '@/app/graphql/account/sdk.account';
import { StatementType } from '@/app/graphql/statement/sdk.statement';

export interface AccountStatementForm {
  account: AccountsWithCurrency | null;
  startDate: string | null;
  endDate: string | null;
  currencies: CurrencyForAccountFragment[];
  statementType: StatementType;
}

export const INITIAL_ACCOUNT_STATEMENT_FORM = {
  account: null,
  startDate: null,
  endDate: null,
  currencies: [],
  statementType: StatementType.WithQrDetails,
};

export const STATEMENT_TYPES = [
  {
    label: 'DOCUMENTS.STATEMENT_ACCOUNT.ORDER.WITHOUT_QR_DETAILS',
    value: StatementType.WithoutQrDetails,
  },
  {
    label: 'DOCUMENTS.STATEMENT_ACCOUNT.ORDER.WITH_QR_DETAILS',
    value: StatementType.WithQrDetails,
  },
];
